import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Transaction } from 'src/app/entities/transaction';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { BaseTableComponent } from '../base-table/base-table.component';
import { TransactionService } from 'src/app/services/transaction.service';
import { AlertService } from 'src/app/services/alert.service';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class TransactionComponent extends BaseTableComponent<Transaction> implements OnInit {

  displayedColumns = ['id', 'code', 'document', 'user', 'email', 'total', 'payment_type', 'created_at', 'status', 'actions'];
  configColumns = [
    {
      key: 'id',
      field_key: 'id',
      type: 'integer',
      title: 'ID',
      classes: 'font-weight-600'
    },
    {
      key: 'total',
      field_key: 'total',
      type: 'money',
      title: 'Total',
      classes: ''
    },
    {
      key: 'created_at',
      field_key: 'created_at',
      type: 'string',
      title: 'Fecha',
      classes: ''
    },
    {
      key: 'payment_type',
      field_key: 'payment_type',
      type: 'option',
      title: 'Tipo',
      classes: '',
      options: {
        '0': {
          title: 'FirstData'
        },
        '1': {
          title: 'MutualCard'
        },
        '2': {
          title: 'Transferencia/Efectivo'
        },
        '3': {
          title: 'MercadoPago'
        }
      }
    },
    {
      key: 'status',
      field_key: 'status',
      type: 'option',
      title: 'Estado',
      classes: '',
      options: {
        '0': {
          title: 'Pendiente'
        },
        '1': {
          title: 'Pagado'
        },
        '2': {
          title: 'Cancelado'
        },
        '3': {
          title: 'Devuelto'
        },
        '4': {
          title: 'Pagado Confirmado'
        },
        '5': {
          title: 'Envio Pendiente'
        },
        '6': {
          title: 'Entregado'
        },
      }
    },
  ];

  filterStatus = -1;
  filterDate;

  constructor(
    protected transactionService: TransactionService,
    protected alertService: AlertService
  ) {
    super(alertService);
    this.service = transactionService;
  }

  ngOnInit(): void {
    this.loadItems();
  }

  onFilters() {
    this.tableModel.resetWhere();
    if (this.filterStatus > -1) {
      this.tableModel.addWhere('status', this.filterStatus);
    }
    if (this.filterDate != undefined) {
      this.tableModel.addWhere('created_at:date', this.filterDate.format('YYYY-MM-DD'));
    }
    if(this.filterSearchNombre != ""){
      this.tableModel.addwhereLike('firstname', this.filterSearchNombre)
    }
    if(this.filterSearchApellido != ""){
      this.tableModel.addwhereLike('lastname', this.filterSearchApellido)
    }
    if(this.filterSearchId != ""){
      this.tableModel.addWhere('transaction.id', this.filterSearchId)
    }
    if(this.filterSearchExternalCode != ""){
      this.tableModel.addwhereLike('mia_user.external_code', this.filterSearchExternalCode)
    }
    this.loadItems();
  }

  onSearch() {
    if (this.filterSearch != '') {
      this.tableModel.addwhereLike('user.document', this.filterSearch);
    } else {
      this.tableModel.resetWhere();
    }
    this.loadItems();
  }
}
